import React from 'react';
import styles from './SelectItemLoader.module.scss';

export const SelectItemLoader = () => {
  const numberOfMembers = 10;
  return (
    <div className={styles.group}>
      <div className={styles.heading}>
        <div className={styles.headingText}></div>
      </div>

      <div className={styles.members}>
        {Array.from({ length: numberOfMembers }, (_, key) => (
          <div className={styles.member} key={key}>
            <div className={styles.memberAvatar}></div>
            <div className={styles.memberName}></div>
          </div>
        ))}
      </div>
    </div>
  );
};
